import styled from 'styled-components';
import { SectionContent } from '@components/Sections/Sections.s';
import { largeLayout } from '@styles/layout';
import { Baseline } from '@components/AnimatedBaseline/AnimatedBaseline.s';
import { darkwhite } from '@styles/colors.ts';

export const ProContentWrapper = SectionContent.extend`
  margin-top: -350px;
  height: 600px;
  position: relative;
  margin-bottom: 50px;
`;

export const FormWrapper = styled.div`
  position: absolute;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  right: 0;
  top: 0;
  bottom: 0;
  width: ${largeLayout.getSize(5)}px;
  display: flex;
  align-items: stretch;
`;

export const TextWrapper = styled.div`
  position: absolute;
  top: 400px;
  left: 0;
  width: ${largeLayout.getSize(6)}px;
`;

export const BaselinePro = Baseline.extend`
  padding-left: 0px;
  font-size: 1.6rem;
  &:before {
    display: none;
  }
`;

export const EspaceProAsideWrapper = styled.div`
  background-color:${darkwhite};
  top: 900px;
  width: 100%;
  padding: 80px 0;
  padding-top: 40px;
`;

export const EspaceProAsideElement = styled.div`
  width: 30%;
`;

export const EspaceProAsideSection = SectionContent.extend`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`;

export const EspaceProCardIconWrapper = styled.div`
  border-radius: 100%;

  & > svg {
    width: 100px;
    height: 100px;
    margin: 25px;
  }
`;



// WEBPACK FOOTER //
// src/app/src/components/ProContent/ProContent.s.ts